/**
 * NotFoundPage Component
 * 
 * 404 error page shown when route is not found.
 */

import { useNavigate } from 'react-router-dom'
import { Home, FileQuestion } from 'lucide-react'
import { Button } from '../../components/ui/button'
import { Card, CardContent } from '../../components/ui/card'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-4">
      <Card className="max-w-md w-full text-center">
        <CardContent className="pt-12 pb-8">
          <FileQuestion className="h-16 w-16 mx-auto text-muted-foreground mb-4" />

          <h1 className="text-6xl font-bold text-primary mb-2">404</h1>

          <h2 className="text-xl font-semibold mb-2">Page Not Found</h2>

          <p className="text-muted-foreground mb-6">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>

          <Button onClick={() => navigate('/')}>
            <Home className="h-4 w-4 mr-2" />
            Go Home
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}

export default NotFoundPage